import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { BRAND } from "../../lib/data";
import { LogOut, CalendarCheck, LineChart } from "lucide-react";

export const AdminHeader = ({ active }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const tab = (key, label, Icon, to) => (
    <button
      data-testid={`admin-nav-${key}`}
      onClick={() => navigate(to)}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors ${
        active === key ? "bg-charcoal text-sand" : "text-stone hover:text-charcoal"
      }`}
    >
      <Icon size={16} strokeWidth={1.5} /> {label}
    </button>
  );

  return (
    <header className="border-b border-charcoal/10 bg-sand/80 backdrop-blur-xl sticky top-0 z-20">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src={BRAND.logo} alt={BRAND.name} className="h-10 w-10 rounded-full object-cover" />
          <div className="hidden sm:block">
            <p className="font-heading text-xl text-charcoal leading-none">Admin</p>
            <p className="text-[10px] uppercase tracking-[0.25em] text-stone mt-1">{user?.email}</p>
          </div>
        </div>

        <nav className="flex items-center gap-1 bg-sand-dark rounded-full p-1 border border-charcoal/5">
          {tab("bookings", "Bookings", CalendarCheck, "/admin")}
          {tab("finance", "Finance", LineChart, "/admin/finance")}
        </nav>

        <button
          data-testid="admin-logout"
          onClick={doLogout}
          className="inline-flex items-center gap-2 text-sm text-stone hover:text-charcoal border border-charcoal/15 rounded-full px-4 py-2.5 transition-colors hover:border-charcoal"
        >
          <LogOut size={16} strokeWidth={1.5} /> <span className="hidden sm:inline">Sign out</span>
        </button>
      </div>
    </header>
  );
};
